/**
 * The two conversions between `<input type="datetime-local">` and the ISO-8601
 * instants the core speaks.
 *
 * `datetime-local` says "2026-08-25T18:30" - no offset - and the backend says
 * "2026-08-25T21:30:00.000Z". The conversion lives here, and not in each page,
 * because every editorial screen with a publication or validity window needs
 * exactly the same pair: it started in `FeedsPage` and the trail curation of
 * card #222 needs it verbatim. A second copy would be a second place to get the
 * timezone wrong, and the symptom - a window off by three hours - is invisible
 * until content fails to appear on the site.
 */

/** ISO-8601 instant -> the local wall-clock string the input renders. */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** What the input holds -> an ISO-8601 instant, or `null` for "no bound". */
export function fromLocalInput(value: string): string | null {
  if (!value.trim()) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}
